<template>
  <div
    class="checkout-skeleton"
    data-testid="checkout-skeleton"
  >
    <span class="checkout-skeleton__bar checkout-skeleton__bar--wallet" />
    <span class="checkout-skeleton__bar checkout-skeleton__bar--divider" />
    <span class="checkout-skeleton__bar checkout-skeleton__bar--field" />
    <div class="checkout-skeleton__row">
      <span class="checkout-skeleton__bar checkout-skeleton__bar--field" />
      <span class="checkout-skeleton__bar checkout-skeleton__bar--field" />
    </div>
    <span
      v-if="withCta"
      class="checkout-skeleton__bar checkout-skeleton__bar--cta"
    />
  </div>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{ withCta?: boolean }>(), { withCta: true });
</script>

<style lang="scss" scoped>
.checkout-skeleton {
  display: flex;
  flex-direction: column;
  width: 100%;

  &__row {
    display: flex;
    gap: 12px;
    margin-top: 11px;

    & > * {
      flex: 1;
      min-width: 0;
    }
  }

  &__bar {
    display: block;
    border-radius: 9px;
    background: linear-gradient(90deg, #f1f2f6 25%, #e4e7ee 37%, #f1f2f6 63%);
    background-size: 400% 100%;
    animation: checkout-skeleton-shimmer 1.4s ease infinite;

    &--wallet {
      height: 53px;
    }

    &--divider {
      height: 10px;
      width: 55%;
      margin: 21px auto 33px;
      border-radius: 5px;
    }

    &--field {
      height: 52px;
    }

    &--cta {
      height: 57px;
      margin-top: 8px;
      border-radius: 28px;
    }
  }
}

@keyframes checkout-skeleton-shimmer {
  0% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0 50%;
  }
}
</style>
